import React, { useContext, useEffect, useRef } from 'react';
import { StaticContext } from '@sm/webassets';

import DeveloperWebBasePage from '../DeveloperWebBasePage';

import './docs.scss';

const Docs = () => {
  const {
    environment: { domain, subdomain, tld },
  } = useContext(StaticContext);
  const frameRef = useRef(null);

  const addEu = subdomain === 'developer.eu' ? 'eu.' : '';
  const comOrCa = tld === 'ca' ? 'ca' : 'com';

  useEffect(() => {
    // Listen to message from child window
    window.addEventListener(
      'message',
      e => {
        if (e.origin !== `https://api.${addEu}${domain}.${comOrCa}`) {
          return;
        }
        const data = e[e.message ? 'message' : 'data'];
        if (data.anchor) {
          window.location.hash = data.anchor;
        }

        if (data.query_string && window.history.pushState) {
          const newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}${data.query_string}${window.location.hash}`;
          window.history.pushState({ path: newurl }, '', newurl);
        }
      },
      false
    );

    if (window.location.hash) {
      const anchor = window.location.hash;
      frameRef.current.src += anchor;
    }
  }, [domain, addEu, comOrCa]);

  return (
    <div className="container-docs" data-testid="Docs__Developer">
      <DeveloperWebBasePage id="Developer - Docs" footer={false} title="SurveyMonkey API Developer Portal">
        <iframe
          title="SurveyMonkey Developer Docs"
          className="docs-frame"
          src={`https://api.${addEu}${domain}.${comOrCa}/v3/docs?api_key=3yr7n6m8sjwvm48x8nhxej52`}
          width="100%"
          frameBorder="0"
          ref={frameRef}
        />
      </DeveloperWebBasePage>
    </div>
  );
};

export default Docs;
